import { FC } from "react";
import { Theme } from "apps/website/maps/Theme.map";
import Text from "apps/website/components/base/Text/Text";
import {
  legacySizeCollectionMap,
} from "apps/website/components/base/Text/Text.map";
import Column from "apps/website/components/layout/Column/Column";
import Container from "apps/website/components/layout/Container/Container";
import Grid from "apps/website/components/layout/Grid/Grid";
import Section from "apps/website/components/layout/Section/Section";
import Spacer from "apps/website/components/layout/Spacer/Spacer";

import TextBody from "../../base/Text/TextBody/TextBody";
import ColumnRowTable from "../../feature/Table/ColumnRowTable/ColumnRowTable";
import {
  brandComparisonTableDataLandingPageTest,
} from "../../feature/Table/BrandComparisonTable/shared/data";

export interface ISectionBrandComparisonTableLandingPageTest {
  title: string;
  body: string;
  theme: Theme;
}

const SectionBrandComparisonTableLandingPageTest: FC<ISectionBrandComparisonTableLandingPageTest> = (
  { title, body, theme },
) => (
  <Section component="SectionBrandComparisonTableLandingPageTest" theme={ theme }>
    <Container>
      <Text tag="h2" display="title" size={ legacySizeCollectionMap.titleLg } align="center">
        { title }
      </Text>
      <Grid>
        <Column>
          <Spacer size="md" />
          <Text size={ legacySizeCollectionMap.bodyLg } align="center" whitespace={ { lg: "preWrap" } }>{ body }</Text>
          <Spacer size="2xl" />
        </Column>
      </Grid>
      <div className="shadow-[10px_10px] shadow-charcoal">
        <ColumnRowTable
          component="BrandComparisonTableLandingPageTest"
          columnTitles={brandComparisonTableDataLandingPageTest.titles}
          rows={brandComparisonTableDataLandingPageTest.rows}
          className="mx-auto"
        />
      </div>
      <div className="pt-8">
        <TextBody size={4} align="center" whitespace="balance">
          { brandComparisonTableDataLandingPageTest.footer }
        </TextBody>
      </div>
    </Container>
  </Section >
);

export default SectionBrandComparisonTableLandingPageTest;
